import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
// These valus are set only in next.js context
export const initialState = {
  FACEBOOK_CLIENT_ID: undefined,
  APPLE_CLIENT_ID: undefined,
  GOOGLE_CLIENT_ID: undefined,
  GOOGLE_MAPS_API_KEY: undefined,
  RELEASE_VERSION: undefined,
  NEXT_JS: undefined,
  CSRF_TOKEN: undefined,
  NODE_ENV: undefined,
  IMG_TAG: undefined
};

const setEnvs = (draft, action) => {
  return action.payload.envs;
};

const nextEnvSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setEnvs
  }
});
export const {
  actions
} = nextEnvSlice;
export const plug = {
  [stateName]: nextEnvSlice.reducer
};
export default nextEnvSlice.reducer;